import React, { useMemo, useState } from 'react';

import { Autocomplete } from '@flixbus/honeycomb-react';
// import { Icon, IconArrowRightArcDots } from '@flixbus/honeycomb-icons-react';

const RunNames = ({
	value = [],
	onSelection = () => {},
	onReset = () => {},
	onSingleItemReset = () => {},
	extraClasses = '',
}) => {
	const [inputValue, setInputValue] = useState('');

	const selectedOptions = useMemo(() => {
		return value.map((item) => ({
			title: item,
			value: item,
		}));
	}, [value]);

	const buildFakeOptions = (typedValue) => {
		if (!typedValue) return [];

		return [
			{
				title: typedValue,
				value: typedValue,
				subtitle: 'Select to add',
			},
		];
	};

	const handleInputChange = (event) => {
		const nextValue = event?.target?.value ?? '';
		setInputValue(nextValue);
	};

	const handleDebounce = (typedValue) => {
		return buildFakeOptions(typedValue);
	};

	const handleAutocompleteChange = (selectedOptions) => {
		const nextSelected = Array.isArray(selectedOptions) ? selectedOptions : [];
		const previousSelectedValues = value;
		const nextSelectedValues = nextSelected.map((item) => item.value);

		if (nextSelectedValues.length > previousSelectedValues.length) {
			const addedValue = nextSelectedValues.find((item) => !previousSelectedValues.includes(item));

			if (addedValue !== undefined) {
				onSelection(addedValue);
				setInputValue('');
			}

			return;
		}

		if (nextSelectedValues.length < previousSelectedValues.length) {
			if (nextSelectedValues.length === 0) {
				onReset();
				return;
			}

			const removedValue = previousSelectedValues.find(
				(item) => !nextSelectedValues.includes(item)
			);

			if (removedValue !== undefined) {
				onSingleItemReset(removedValue);
			}
		}
	};

	return (
		<Autocomplete
			extraClasses={extraClasses}
			multiple
			value={selectedOptions}
			inputValue={inputValue}
			options={buildFakeOptions(inputValue)}
			debounce={300}
			onDebounce={handleDebounce}
			onChange={handleAutocompleteChange}
			comboboxProps={{
				label: 'Run number',
				placeholder: 'E.g. 01, 02',
				limitSelectedOptions: 3,

				// iconLeft: <Icon InlineIcon={IconArrowRightArcDots} />,
				onChange: handleInputChange,
				tagProps: (selectedOption) => ({
					closeProps: {
						label: `Remove ${selectedOption.title}`,
					},
				}),
			}}
			listBoxProps={{
				label: 'Run names',
				optionsToDisplay: 5,
			}}
		/>
	);
};

export default RunNames;
